
import axios from 'axios' 
import axiosCommon from './axiosCommon.js'

export function sendEmail(params, that) { 
  return axiosCommon({
    url: '/rest/mgmt/sendMail', 
    method: 'post',
    data: params,
    cancelToken: new axios.CancelToken(function executor(c) { // 设置 cancel token
      that.source = c;
    })
  })
}

